import { FILTER_FEATURE, PARTNER_MANAGEMENT } from "api/ApiPath";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { BaseFilterListRequestModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListRequestModel";
import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { FilterUseCase } from "app/filters/domain/useCase/FilterUseCase";
import { ErrorCodeGeneralInjection } from "features/errorCodeGeneralFeature/di/ErrorCodeGeneralInjection";
import { injectable } from "tsyringe";
import { tempService } from "utils/dummyData/TempService";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";
import { DetailErrorCodeGeneralEntity } from "../entities/DetailErrorCodeGeneralEntity";
import { ErrorCodeGeneralRequestEntity } from "../entities/ErrorCodeGeneralRequestEntity";
import { ErrorCodeGeneralResponseEntity } from "../entities/ErrorCodeGeneralResponseEntity";
import { PartnerResponseEntity } from "../entities/PartnerResponseEntity";
import { IErrorCodeGeneralRepository } from "../repositories/IErrorCodeGeneralRepository";

@injectable()
export class ErrorCodeGeneralUseCase {
  private errorCodeGeneralRepo: IErrorCodeGeneralRepository;
  private filterUseCase: FilterUseCase;

  constructor() {
    this.errorCodeGeneralRepo = ErrorCodeGeneralInjection.getRepo();
    this.filterUseCase = FilterInjection.getUseCase();
  }

  async fetchGeneral(
    params: ErrorCodeGeneralRequestEntity,
  ): Promise<ListBaseApiResponseModel<ErrorCodeGeneralResponseEntity>> {
    delete params?.timeType;
    delete params?.classType;
    return await this.errorCodeGeneralRepo.fetchGeneral(params);
  }

  async fetchDetail(
    params: ErrorCodeGeneralRequestEntity,
  ): Promise<ListBaseApiResponseModel<DetailErrorCodeGeneralEntity>> {
    return await this.errorCodeGeneralRepo.fetchDetail(params);
  }

  async fetchReport(
    params: ErrorCodeGeneralRequestEntity,
  ): Promise<BaseApiResponseModel<Blob>> {
    return await this.errorCodeGeneralRepo.fetchReport(params);
  }

  async getService(
    params: BaseFilterListRequestModel,
  ): Promise<Array<BaseFilterListResponseModel>> {
    const res = await this.filterUseCase.fetchListWithFeature({
      path: FILTER_FEATURE.SERVICE_LIST,
      isNeedFeature: true,
      isForceRefresh: false,
      needExpired: false,
      savedKey: CacheKeyEnum.serviceList,
      params,
    });
    if (!!res) {
      return res;
    } else {
      return tempService;
    }
  }

  async getPartner(
    params: BaseFilterListRequestModel,
  ): Promise<Array<PartnerResponseEntity>> {
    return await this.filterUseCase.fetchListWithFeature({
      path: PARTNER_MANAGEMENT.LIST,
      isNeedFeature: true,
      isForceRefresh: false,
      needExpired: false,
      savedKey: CacheKeyEnum.partnerList,
      params,
    });
  }
}
